<template>
  <div v-bind="$attrs">
    <label>
      {{ label }}
      <v-item-group v-model="value" mandatory class="d-flex">
        <template v-for="(item, index) in items" :key="index">
          <v-item v-slot="{ isSelected, toggle }">
            <v-card
              :color="disabled && isSelected ? 'grey' : isSelected ? color : ''"
              :class="{
                'font-weight-medium': isSelected,
                'text-disabled so-button-group--disabled': disabled,
              }"
              :disabled="disabled"
              class="so-button-group d-flex align-center justify-center px-4"
              height="36"
              rounded="0"
              elevation="0"
              tabindex="0"
              data-testid="so-button-group-item"
              @click.stop="toggle && toggle()"
              @keyup.enter.stop="!disabled && toggle && toggle()"
            >
              {{ item }}
            </v-card>
          </v-item>
        </template>
      </v-item-group>
    </label>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  type SoButtonGroupType = "primary" | "inverted"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: String,
        default: null,
      },
      type: {
        type: String as PropType<SoButtonGroupType>,
        default: "primary",
      },
      items: {
        type: Array as PropType<string[]>,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get(): number {
          return this.items.indexOf(this.modelValue)
        },
        set(val: number) {
          this.$emit("update:modelValue", this.items[val])
        },
      },
      color() {
        switch (this.type) {
          case "primary":
            return "success so-button-group--primary"
          case "inverted":
            return "inverted so-button-group--inverted"
          default:
            return "success so-button-group--primary"
        }
      },
    },
  })
</script>

<style>
  .so-button-group {
    border: 1px solid rgb(var(--v-theme-on-surface));
  }
  .so-button-group:nth-child(n + 2) {
    border-left: none;
  }
  .so-button-group:first-child {
    border-radius: var(--theme-radius) 0 0 var(--theme-radius) !important;
  }
  .so-button-group:last-child {
    border-radius: 0 var(--theme-radius) var(--theme-radius) 0 !important;
  }
  .so-button-group:focus-visible {
    outline: var(--theme-outline);
  }
  .so-button-group--inverted:focus-visible {
    outline-color: rgb(var(--v-theme-sky-light));
  }
  .so-button-group--disabled {
    border-color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity));
  }
</style>
